<template>
  <nav v-if="show" class="app-top-bar" aria-label="Поиск и уведомления">
    <v-btn
      icon
      class="app-top-bar__action"
      :to="{ path: '/search' }"
      title="Поиск по CRM"
      aria-label="Поиск по CRM"
    >
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
    <v-btn
      icon
      class="app-top-bar__action"
      :to="{ path: '/notifications' }"
      title="Уведомления"
      :aria-label="unreadCount > 0 ? `Уведомления: ${unreadCount} непрочитанных` : 'Уведомления'"
    >
      <v-badge
        :content="unreadCount"
        :value="unreadCount > 0"
        overlap
        color="error"
        aria-hidden="true"
      >
        <v-icon>mdi-bell-outline</v-icon>
      </v-badge>
    </v-btn>
  </nav>
</template>

<script>
import axios from '@/plugins/axios'

export default {
  name: 'AppTopBar',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unreadCount: 0,
      pollTimer: null,
    }
  },
  mounted() {
    this.$root.$on('notifications:updated', this.onUpdated)
    this.$root.$on('notifications:refresh', this.fetchUnreadCount)
    if (this.show) {
      this.fetchUnreadCount()
      this.pollTimer = setInterval(this.fetchUnreadCount, 120000)
    }
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
    }
    this.$root.$off('notifications:updated', this.onUpdated)
    this.$root.$off('notifications:refresh', this.fetchUnreadCount)
  },
  watch: {
    show(value) {
      if (value) {
        this.fetchUnreadCount()
        if (!this.pollTimer) {
          this.pollTimer = setInterval(this.fetchUnreadCount, 120000)
        }
      } else if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
  },
  methods: {
    onUpdated(count) {
      this.unreadCount = count
    },
    async fetchUnreadCount() {
      try {
        const response = await axios.get('user-notifications/unread-count')
        this.unreadCount = response.unread_count || 0
      } catch (e) {
        // ignore background errors
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/navigation-common.scss';

.app-top-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: $spacing-2;
  box-sizing: border-box;
  min-height: calc(#{$spacing-12} + env(safe-area-inset-top, 0px));
  padding: $spacing-1 $spacing-6;
  padding-top: calc(#{$spacing-1} + env(safe-area-inset-top, 0px));
  padding-left: max(#{$spacing-6}, env(safe-area-inset-left, 0px));
  padding-right: max(#{$spacing-6}, env(safe-area-inset-right, 0px));

  .app-top-bar__action {
    flex: 0 0 auto;
    // Keep the full badge inside its link, including the area beyond the icon.
    overflow: visible;
  }

  @include mobile {
    min-height: calc(#{$spacing-12 + $spacing-2} + env(safe-area-inset-top, 0px));

    .app-top-bar__action {
      width: $spacing-12;
      min-width: $spacing-12;
      height: $spacing-12;
    }
  }
}
</style>
